export default "__VITE_ASSET__CvKF3XGW__"